/**
 * @generated SignedSource<<fc59aee64ab0b634adc502b66d707879>>
 * @relayHash 0fd2a3241ae778871c0d927de9905467
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID f80da8e1c2e442a9eacf6e4f94a43f08dc7ca662f8c8ba98511c1d789dc8b94c

import type { ConcreteRequest } from 'relay-runtime';
export type GrowthRecRerankCandidate = {
  context?: AGG$JSON | null;
  entityId: string;
};
export type InvitedAppShortcutsRecommendationsQuery$variables = {
  product: string;
  rerank?: ReadonlyArray<GrowthRecRerankCandidate> | null;
  tenantId?: string | null;
};
export type InvitedAppShortcutsRecommendationsQuery$data = {
  readonly growthRecommendations: {
    readonly recommendations: {
      readonly __typename: "GrowthRecRecommendations";
      readonly context: {
        readonly product: string | null;
        readonly sessionId: string | null;
        readonly tenantId: string | null;
        readonly useCase: string | null;
      } | null;
      readonly data: ReadonlyArray<{
        readonly entityId: string;
        readonly reasons: ReadonlyArray<string> | null;
        readonly score: number | null;
      }> | null;
    } | {
      readonly __typename: "QueryError";
      readonly extensions: ReadonlyArray<{
        readonly errorType: string | null;
        readonly statusCode: number | null;
      }> | null;
      readonly identifier: string | null;
      readonly message: string | null;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null;
  } | null;
};
export type InvitedAppShortcutsRecommendationsQuery = {
  response: InvitedAppShortcutsRecommendationsQuery$data;
  variables: InvitedAppShortcutsRecommendationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "product"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rerank"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tenantId"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "product",
        "variableName": "product"
      },
      {
        "kind": "Variable",
        "name": "tenantId",
        "variableName": "tenantId"
      },
      {
        "kind": "Literal",
        "name": "useCase",
        "value": "invitedAppShortcuts"
      }
    ],
    "kind": "ObjectValue",
    "name": "context"
  },
  {
    "kind": "Variable",
    "name": "rerank",
    "variableName": "rerank"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v5 = {
  "kind": "ScalarField",
  "name": "entityId"
},
v6 = {
  "kind": "ScalarField",
  "name": "reasons"
},
v7 = {
  "kind": "ScalarField",
  "name": "score"
},
v8 = {
  "concreteType": "GrowthRecContextResult",
  "kind": "LinkedField",
  "name": "context",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "tenantId"
    },
    {
      "kind": "ScalarField",
      "name": "product"
    },
    {
      "kind": "ScalarField",
      "name": "useCase"
    },
    {
      "kind": "ScalarField",
      "name": "sessionId"
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "identifier"
},
v10 = {
  "kind": "ScalarField",
  "name": "message"
},
v11 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v12 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "InvitedAppShortcutsRecommendationsQuery",
    "selections": [
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  (v8/*: any*/)
                ],
                "type": "GrowthRecRecommendations"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ]
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "InvitedAppShortcutsRecommendationsQuery",
    "selections": [
      {
        "concreteType": "GrowthRecQuery",
        "kind": "LinkedField",
        "name": "growthRecommendations",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "recommendations",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "data",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/)
                    ]
                  },
                  (v8/*: any*/)
                ],
                "type": "GrowthRecRecommendations"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v9/*: any*/),
                  (v10/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v11/*: any*/),
                      (v12/*: any*/)
                    ]
                  }
                ],
                "type": "QueryError"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "f80da8e1c2e442a9eacf6e4f94a43f08dc7ca662f8c8ba98511c1d789dc8b94c",
    "metadata": {},
    "name": "InvitedAppShortcutsRecommendationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8b93ffadc588af32bf0b948a61c02a0d";

export default node;
